<template>
  <profile-container>
    <template v-slot:title>
      <capusta-title :title="$t('account.secure')" icon-outside>
        <template v-slot:description>
          <div class="main-description" v-html="$t('additional.login.confirmation')"></div>
        </template>
      </capusta-title>
    </template>

    <template v-slot:content>
      <div v-for="twoFactor in types" :key="twoFactor.name" class="panel-list">
        <toggle-panel
          :title="$t(twoFactor.name)"
          :value="twoFactor.value"
          @click="onSwitch(twoFactor)"
        >
          <component :is="getIconComponent(twoFactor.type)" slot="icon" />
        </toggle-panel>
      </div>
    </template>

    <template v-slot:icon>
      <background-icon :active="!!currentFactor" icon="2fa" />
    </template>
  </profile-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import HTTPService from '@/services/Http';

import MailIcon from 'atoms/icons/basic/Mail';
import TelegramIcon from 'atoms/icons/symbols/Telegram';

import CapustaTitle from 'modules/CapustaLayout/CapustaTitle';
import TogglePanel from 'molecules/panels/TogglePanel';

import ProfileContainer from '@/pages/profile/ProfileContainer';
import BackgroundIcon from '@/pages/profile/components/BackgroundIcon';

import { TELEGRAM_OPEN } from 'root/.env';
import { BOT_SIGN_ON_EVENT, BOT_SIGN_OFF_EVENT } from '@/const';

const EMAIL = 'EMAIL';
const TELEGRAM = 'TELEGRAM';

const TWO_FACTOR_ICONS_MAP = {
  [EMAIL]: MailIcon,
  [TELEGRAM]: TelegramIcon,
};

export default {
  name: 'ProfileTwoFactor',
  components: {
    CapustaTitle,
    TogglePanel,
    ProfileContainer,
    BackgroundIcon,
  },
  created() {
    this.fetch();
  },
  mounted() {
    window.addEventListener(BOT_SIGN_OFF_EVENT, this.deactivateTelegram);
  },
  beforeDestroy() {
    window.removeEventListener(BOT_SIGN_OFF_EVENT, this.deactivateTelegram);
  },
  data() {
    return {
      currentFactor: null,
    };
  },
  computed: {
    ...mapState(['MERCHANT_INFO']),
    ...mapGetters('twoFactor', ['types']),
  },
  watch: {
    types() {
      if (!this.types || !this.MERCHANT_INFO) {
        return;
      }

      const { twoFactorAuthTypeId } = this.MERCHANT_INFO;

      // фактор еще не установлен
      if (twoFactorAuthTypeId === 0) {
        // eslint-disable-next-line no-console
        console.log('фактор еще не установлен', twoFactorAuthTypeId);
        return;
      }

      // поиск установленного фактора
      const findedFactor = this.types.find(item => item.id === twoFactorAuthTypeId);
      // eslint-disable-next-line no-console
      console.log('поиск установленного фактора', findedFactor);

      if (this.$validate.isUndefined(findedFactor) || !this.$validate.isObjectWithFields(findedFactor, ['id'])) {
        return;
      }

      findedFactor.value = true;

      // сохраняем активный фактор
      this.currentFactor = findedFactor;
      // eslint-disable-next-line no-console
      console.log('сохраняем активный фактор', this.currentFactor.type);
    },
  },
  methods: {
    getIconComponent(iconName) {
      return TWO_FACTOR_ICONS_MAP[iconName];
    },
    deactivateTelegram() {
      if (this.$validate.isNull(this.currentFactor)) {
        return;
      }

      if (this.currentFactor.type !== TELEGRAM) {
        return;
      }

      this.currentFactor.value = false;
      // eslint-disable-next-line no-console
      console.log('фактор телеграмма деактивирован');
    },
    onSwitch(item) {
      const { botSigned } = this.MERCHANT_INFO;
      // eslint-disable-next-line no-console
      console.log('onSwitch', item, `botSigned: ${botSigned}`);

      if (item.type === TELEGRAM && !botSigned) {
        // TODO: подумать как вынести это отсюда
        window.addEventListener(BOT_SIGN_ON_EVENT, () => {
          this.onSwitch(item);
        }, { once: true });

        this.openTelegram();
        return;
      }

      if (this.$validate.isNotNull(this.currentFactor) && this.currentFactor.id !== item.id) {
        // eslint-disable-next-line no-console
        console.log('сбросили текущий активный фактор', this.currentFactor.type);
        this.currentFactor.value = false;
      }

      item.value = !item.value;

      this.currentFactor = item.value ? item : null;
      this.sendRequest(item);
    },
    openTelegram() {
      this.$alert({
        type: 'warning',
        text: this.$t('log.in.telegram.and.try.again'),
      });

      HTTPService.telegramBotGetToken()
        .then(response => {
          this.$openLink(`http://${TELEGRAM_OPEN}?start=${response.data}`, true);
        })
        .catch(() => {
          this.$alert({
            type: 'warning',
            text: this.$t('binding.bot.error'),
          });
        });
    },
    sendRequest(data) {
      if (!data.value) {
        // eslint-disable-next-line no-console
        console.log('отключили фактор', data.type);
        this.cancel();
        return;
      }

      // eslint-disable-next-line no-console
      console.log('выбрали новый фактор', data.type);
      this.select({
        id: data.id,
        type: data.type,
      });
    },
    ...mapActions('twoFactor', {
      fetch: 'fetchTypes',
      select: 'changeSelection',
      cancel: 'twoFactorCancel',
    }),
  },
};
</script>

<style lang="sass" module>

</style>

<style lang="sass" scoped>
  .main-description
    &::deep span
      display: block

      +respond-to('medium')
        display: inline

  .panel-list
    &:not(:last-child)
      margin-bottom: 10px
</style>
